import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

function screenshotsForLanguage(language: string) {
  const suffix = language.startsWith('es') ? '_es' : '';
  return [1, 2, 3, 4].map((index) => `/madeinspain${index}${suffix}.png`);
}

export function ScreenshotCarousel() {
  const { t, i18n } = useTranslation();
  const screenshots = useMemo(
    () => screenshotsForLanguage(i18n.language),
    [i18n.language],
  );
  const slides = [...screenshots, ...screenshots];

  return (
    <div className="screenshot-carousel" aria-label={t('home.heroAlt')}>
      <div className="screenshot-carousel__viewport">
        <div className="screenshot-carousel__track">
          {slides.map((src, index) => (
            <img
              key={`${src}-${index}`}
              src={src}
              alt={t('home.heroAlt')}
              className="screenshot-carousel__slide"
              loading={index < 2 ? 'eager' : 'lazy'}
              decoding="async"
              draggable={false}
            />
          ))}
        </div>
      </div>
      <div className="screenshot-carousel__edge screenshot-carousel__edge--left" aria-hidden />
      <div className="screenshot-carousel__edge screenshot-carousel__edge--right" aria-hidden />
    </div>
  );
}
